// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { circleBroken16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-circle-broken': IconCircleBroken;
    }
}

/**
 * The icon component for the 'circleBroken' icon
 */
export class IconCircleBroken extends Icon {
    public constructor() {
        super(circleBroken16X16);
    }
}

registerIcon('icon-circle-broken', IconCircleBroken);
export const iconCircleBrokenTag = 'nimble-icon-circle-broken';
